"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const TeamsCommitteesAndCouncilsIcon = createIcon({
  displayName: "TeamsCommitteesAndCouncilsIcon",
  viewBox: "0 0 45 22",
  path: (
    <>
      <path
        d="M0,22v-2.89c0-1.31.69-2.38,2.06-3.21,1.38-.82,3.19-1.24,5.44-1.24.41,0,.8,0,1.17.02s.73.05,1.08.11c-.44.64-.77,1.31-.98,2.02-.22.7-.33,1.44-.33,2.2v2.98H0ZM11.25,22v-2.98c0-.98.27-1.87.82-2.68s1.32-1.52,2.32-2.13c1-.61,2.2-1.07,3.59-1.38,1.39-.31,2.9-.46,4.52-.46s3.18.15,4.57.46c1.39.31,2.59.76,3.59,1.38,1,.61,1.77,1.32,2.3,2.13.53.81.8,1.7.8,2.68v2.98H11.25ZM36.56,22v-2.98c0-.79-.1-1.54-.3-2.25-.2-.7-.51-1.36-.91-1.97.34-.06.7-.1,1.05-.11.36-.02.73-.02,1.1-.02,2.25,0,4.06.4,5.44,1.21,1.38.81,2.06,1.89,2.06,3.23v2.89h-8.44ZM15.23,18.33h14.58c-.31-.61-1.18-1.15-2.6-1.6-1.42-.46-2.99-.69-4.71-.69s-3.29.23-4.71.69c-1.42.46-2.27.99-2.55,1.6ZM7.5,12.83c-1.03,0-1.91-.36-2.65-1.08-.73-.72-1.1-1.58-1.1-2.59s.37-1.91,1.1-2.61c.73-.7,1.62-1.05,2.65-1.05s1.95.35,2.67,1.05c.72.7,1.08,1.57,1.08,2.61s-.36,1.87-1.08,2.59c-.72.72-1.61,1.08-2.67,1.08ZM37.5,12.83c-1.03,0-1.91-.36-2.65-1.08-.73-.72-1.1-1.58-1.1-2.59s.37-1.91,1.1-2.61c.73-.7,1.62-1.05,2.65-1.05s1.95.35,2.67,1.05c.72.7,1.08,1.57,1.08,2.61s-.36,1.87-1.08,2.59c-.72.72-1.61,1.08-2.67,1.08ZM22.5,11c-1.56,0-2.89-.53-3.98-1.6-1.09-1.07-1.64-2.37-1.64-3.9s.55-2.86,1.64-3.92c1.09-1.05,2.42-1.58,3.98-1.58s2.93.53,4.01,1.58c1.08,1.05,1.62,2.36,1.62,3.92s-.54,2.83-1.62,3.9c-1.08,1.07-2.41,1.6-4.01,1.6ZM22.5,7.33c.53,0,.98-.18,1.34-.53.36-.35.54-.79.54-1.31s-.18-.95-.54-1.31c-.36-.35-.8-.53-1.34-.53s-.98.18-1.34.53c-.36.35-.54.79-.54,1.31s.18.95.54,1.31c.36.35.8.53,1.34.53Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default TeamsCommitteesAndCouncilsIcon;
